<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1.5rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 4a8 8 0 11-8 8 8 8 0 018-8m0-2a10 10 0 1010 10A10 10 0 0012 2z"/><path d="M10.72 9.77L14.36 12l-3.64 2.22V9.77M9.73 7a1 1 0 00-1 1v8a1 1 0 001 1 .94.94 0 00.52-.15l6.55-4a1 1 0 000-1.71l-6.55-4A1 1 0 009.73 7z"/></svg>